import type { RegistryItemTextInputProps } from 'app/src/model'
import { FloatLabel } from 'primereact/floatlabel'
import { InputText } from 'primereact/inputtext'

export function RegistryTextInput(props: RegistryItemTextInputProps) {
  const { labelProps, ...textProps } = props
  return (
    <>
      <FloatLabel>
        <InputText
          pt={{
            root: { className: 'rounded-none !border-x-0 !border-b border-solid !border-t-0 !border-[#D9D9D9]' },
          }}
          {...textProps}
          aria-labelledby={`${textProps.id}-label`}
        />
        <label id={`${textProps.id}-label`} htmlFor={textProps.id}>
          {labelProps.text}
        </label>
      </FloatLabel>
    </>
  )
}
